import React from "react";
import SEO from "@/components/SEO";
import Hero from "@/sections/Hero";
import Showcase from "@/sections/Showcase";
import WhyStorage from "@/sections/WhyStorage";
import ProductSection from "@/sections/ProductSection";
import Specs from "@/sections/Specs";
import BrandConnection from "@/sections/BrandConnection";
import FaqSection from "@/sections/FaqSection";
import ClosingCTA from "@/sections/ClosingCTA";

export default function Home() {
  return (
    <>
      <SEO
        title="PeptiChill — Precision cooling for peptide storage"
        description="A compact, clinical-grade cooler fridge designed for research-use peptides and temperature-sensitive laboratory materials. Pre-order open — ships July 2026. By Peptigen Labs."
        path="/"
      />
      <Hero />
      <Showcase />
      <WhyStorage />
      <ProductSection />
      <Specs />
      <BrandConnection />
      <FaqSection />
      <ClosingCTA />
    </>
  );
}
